import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {IntelligenceSearchInterface} from '../../../models/intelligence-search.interface';
import {ActivatedRoute} from '@angular/router';
import {setFormValuesFromQueryParams} from '../../../utils/filters-utils';

@Component({
  selector: 'app-re-use-targets-filters',
  templateUrl: './re-use-targets-filters.component.html',
  styleUrls: ['./re-use-targets-filters.component.scss']
})
export class ReUseTargetsFiltersComponent implements OnInit {


  responseType = [
    {value: 'true', description: 'Yes'},
    {value: 'false', description: 'No'},
    {value: 'N/A', description: 'N/A'},
  ];

  searchForm = this.formBuilder.group({
    responseType: [''],
  });

  get responseTypeControl(): FormControl {
    return this.searchForm.get('responseType') as FormControl;
  }

  @Output()
  search: EventEmitter<IntelligenceSearchInterface> = new EventEmitter<IntelligenceSearchInterface>();

  constructor(private formBuilder: FormBuilder,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  handleSubmit(): void {
    this.search.emit({
      year: 0,
      responseType: this.responseTypeControl.value
    } as IntelligenceSearchInterface);
  }

  clean(): void {
    this.responseTypeControl.setValue(null);
    this.search.emit({
      year: 0,
    } as IntelligenceSearchInterface);
  }

}
